import React, { useState, useEffect } from 'react';

import {
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
} from '@material-ui/core';
import PropTypes from 'prop-types';

import Card from '../Card';
import SemDados from '../SemDados';
import * as S from './styles';

function CardTurnos({ title, icon, headers, data, tooltip, style, disabled }) {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  const totalPages = Math.ceil(data.length / itemsPerPage);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

  const handleNextPage = () => {
    setCurrentPage((prevPage) => (prevPage < totalPages ? prevPage + 1 : 1));
  };

  /* const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  }; */

  useEffect(() => {
    setCurrentPage(1); // reset ao mudar os dados
  }, [data]);

  useEffect(() => {
    if (totalPages > 1) {
      const timer = setInterval(() => {
        setCurrentPage((prevPage) =>
          prevPage < totalPages ? prevPage + 1 : 1
        );
      }, 10000);

      return () => clearInterval(timer);
    }
  }, [totalPages]);

  const corCelulaData = (dias) => {
    if (dias <= 0 || dias >= 30) {
      return '#d32f2f';
    }

    if (dias > 0 && dias <= 2) {
      return 'green';
    }

    return 'darkorange';
  };

  return (
    <Card
      title={title}
      icon={icon}
      tooltip={tooltip}
      disabled={disabled}
      paginacao={totalPages > 1 ? `${currentPage}/${totalPages}` : ''}
      style={style}
    >
      {data && data.length > 0 ? (
        <S.Container style={{ '--total-table-rows': currentItems.length + 1 }}>
          <TableContainer>
            <Table aria-label="simple table">
              <TableHead>
                <TableRow>
                  {headers.map((header) => (
                    <TableCell key={header}>{header}</TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {currentItems.map((row, index) => (
                  <TableRow tabIndex={-1} key={`table-row-body-${index}`}>
                    <TableCell key="table-cell-body-1">
                      {row.nomeabreviadoposto}
                    </TableCell>
                    <TableCell
                      key="table-cell-body-2"
                      style={{
                        backgroundColor: corCelulaData(row.dias),
                        color: '#fff',
                        textAlign: 'center',
                        padding: 0,
                      }}
                    >
                      {row.dataturno && typeof row.dataturno === 'string'
                        ? row.dataturno
                        : '-'}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </S.Container>
      ) : (
        <SemDados />
      )}
    </Card>
  );
}

CardTurnos.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.element.isRequired,
  headers: PropTypes.arrayOf(PropTypes.string).isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      idposto: PropTypes.number,
      nomeabreviadoposto: PropTypes.string.isRequired,
      dataturno: PropTypes.string,
      dias: PropTypes.number.isRequired,
    })
  ).isRequired,
  tooltip: PropTypes.string.isRequired,
  style: PropTypes.objectOf(PropTypes.any),
  disabled: PropTypes.bool,
};

CardTurnos.defaultProps = {
  style: {},
  disabled: false,
};

export default CardTurnos;
